import React from 'react';
import { css } from 'glamor';
import { ToastContainer } from 'react-toastify';
import { makeStyles } from '@material-ui/core/styles';

import 'react-toastify/dist/ReactToastify.css';

const useStyles = makeStyles({
  '@global': {
    '.Toastify__toast': {
      background: 'transparent !important',
      borderRadius: '25px',
      overflow: 'hidden'
    }
  }
});

const NotificationProvider = () => {
  useStyles();

  return (
    <>
      <ToastContainer
        closeButton={false}
        className={css({
          zIndex: '500001 !important',
          margin: '0 !important',
          transform: 'translate(-50%,0) !important',
          width: '100% !important',

          maxWidth: '600px  !important',
          '@media (max-width:480px)': {
            transform: 'none !important'
          }
        })}
        position="top-center"
        autoClose={4000}
        newestOnTop
      />
    </>
  );
};

export default NotificationProvider;
